import React, { useRef, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { init, sendForm } from '@emailjs/browser';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/contactForm.css';

const ContactForm = () => {
  const { t } = useTranslation();
  const formRef = useRef();
  const [status, setStatus] = useState(null);

  // Alustetaan EmailJS kerran julkisella avaimella
  useEffect(() => {
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    if (publicKey) {
      init(publicKey);
    } else {
      console.error('EmailJS public key puuttuu! Tarkista .env');
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('sending');

    sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formRef.current
    )
      .then(() => {
        setStatus('success');
        formRef.current.reset();
      })
      .catch((err) => {
        console.error('EmailJS error:', err);
        setStatus('error');
      });
  };

  return (
    <div className="mt-4">
      <form ref={formRef} onSubmit={handleSubmit}>
        <div className="form-group pb-4">
          <label htmlFor="name">{t('contact.organization')}</label>
          <input
            type="text"
            className="form-control grey-textarea"
            id="name"
            name="name"
            required
          />
        </div>

        <div className="form-group pb-4">
          <label htmlFor="email">{t('contact.email')}</label>
          <input
            type="email"
            className="form-control grey-textarea"
            id="email"
            name="email"
            required
          />
        </div>

        <div className="form-group pb-5">
          <label htmlFor="message">{t('contact.message')}</label>
          <textarea
            className="form-control grey-textarea"
            id="message"
            name="message"
            rows="4"
            required
          />
        </div>

        <button
          type="submit"
          className="btn btn-secondary"
          disabled={status === 'sending'}
        >
          {status === 'sending' ? t('contact.sending') : t('contact.send')}
        </button>

        {status === 'success' && (
          <div className="alert alert-success mt-3">
            {t('contact.success')}
          </div>
        )}
        {status === 'error' && (
          <div className="alert alert-danger mt-3">
            {t('contact.error')}
          </div>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
